import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import type { FeatureThemeKey } from '@/lib/productBranding'
import FeatureThemeProvider from './FeatureThemeProvider'

type FeatureShellProps = {
  featureKey: FeatureThemeKey
  header?: ReactNode
  children: ReactNode
  className?: string
  headerClassName?: string
  bodyClassName?: string
  withAntd?: boolean
  glow?: boolean
}

export default function FeatureShell({
  featureKey,
  header,
  children,
  className,
  headerClassName,
  bodyClassName = 'p-6',
  withAntd = false,
  glow = false,
}: FeatureShellProps) {
  return (
    <FeatureThemeProvider featureKey={featureKey} withAntd={withAntd}>
      <div className={twMerge('feature-shell', className)}>
        {glow && <div className="feature-shell__glow" aria-hidden />}
        {header && (
          <div className={twMerge('feature-shell__header px-6 pt-5 pb-4', headerClassName)}>
            {header}
          </div>
        )}
        <div className={bodyClassName}>{children}</div>
      </div>
    </FeatureThemeProvider>
  )
}
